<mat-sidenav-container
  *ngIf="securityService?.currentUserValue"
  class="sidenav-container"
>
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <div
      class="topo-menu"
      [ngClass]="
        'bg-action-' +
        securityService.currentUserValue?.empresa?.cor_lowercase.toLowerCase()
      "
    >
      <mat-list>
        <mat-list-item>
          <h3 class="font-weight-bold text-white" matLine>
            {{ securityService.currentUserValue?.nome }}
          </h3>
          <p matLine>
            <span class="text-white-50">
              {{ securityService.currentUserValue?.email }}
            </span>
          </p>
          <p matLine>
            <span class="text-white-50">
              {{ securityService.currentUserValue?.empresa?.nome }}
            </span>
          </p>
        </mat-list-item>
      </mat-list>
    </div>

    <mat-nav-list>
      <a mat-list-item (click)="drawer.toggle()" [routerLink]="['perfil']">
        Meu Perfil
        <mat-icon matListIcon>face</mat-icon>
      </a>
      <a mat-list-item (click)="drawer.toggle()" [routerLink]="['']">
        Painel
        <mat-icon matListIcon>dashboard</mat-icon>
      </a>
      <a
        mat-list-item
        (click)="drawer.toggle()"
        [routerLink]="['busca-cliente']"
      >
        Consulta cliente
        <mat-icon matListIcon>search</mat-icon>
      </a>

      <a mat-list-item (click)="drawer.toggle()" [routerLink]="['lembretes']">
        Lembretes
        <mat-icon matListIcon mat>notifications</mat-icon>
      </a>

      <a
        *ngIf="securityService?.currentUserValue?.admin"
        mat-list-item
        (click)="drawer.toggle(); openAcessoSimuladoModal()"
      >
        Acesso simulado
        <mat-icon matListIcon>login</mat-icon>
      </a>

      <mat-divider></mat-divider>
      <a mat-list-item (click)="logout()" href="#">
        Sair
        <mat-icon matListIcon>exit_to_app</mat-icon>
      </a>
      <a style="color: #ccc" mat-list-item>
        {{ appVersion }}
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content id="content">
    <mat-toolbar
      [ngClass]="
        'bg-cinza-' +
        securityService?.currentUserValue?.empresa?.cor_lowercase.toLowerCase()
      "
    >
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <div class="logo p-2">
        <img [src]="securityService?.currentUserValue?.empresa?.url_logo" />
      </div>
    </mat-toolbar>

    <router-outlet></router-outlet>

    <div
      class="rodape p-2 text-center text-white-50"
      [ngClass]="
        'bg-cinza-' +
        securityService?.currentUserValue?.empresa?.cor_lowercase.toLowerCase()
      "
    >
      powered by DBMAX
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
